import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../lib/seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { ServiceRow } from "../components/bits";
import { SERVICES } from "../data/services";

export const Services = () => (
  <>
    <Seo
      title="Legal Services"
      description="Corporate and commercial law, trademark and IP protection, contract drafting, property due diligence, regulatory compliance and dispute resolution services in India."
      path="/services"
    />
    <PageHero
      eyebrow="Legal Services"
      title={["Six practice areas,", "one standard of care."]}
      description="Advisory, documentation, filing assistance and coordinated representation — each service states clearly where we advise, where we draft, where we file, and where matters are conducted with instructed advocates."
    />
    <section className="bg-white py-20 sm:py-24">
      <div className="container-x">
        {SERVICES.map((s, i) => (
          <ServiceRow key={s.slug} service={s} index={i} />
        ))}
      </div>
    </section>
    <section className="bg-canvas py-20 sm:py-24">
      <div className="container-x text-center">
        <Reveal>
          <p className="eyebrow">Not sure where your matter fits?</p>
          <h2 className="mx-auto mt-5 max-w-2xl text-3xl font-medium tracking-tight text-ink sm:text-4xl">
            Describe it briefly — we will point you to the right practice area.
          </h2>
          <Link to="/contact" className="btn-gold mt-9" data-testid="services-cta-button">
            Submit a Legal Enquiry <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export default Services;
